// Relais de session depuis l'extension Chrome (« SSO » interne).
//
// Chaque contexte d'embarquement de l'app (side panel de l'extension, iframe
// dans Doctolib) a sa PROPRE jarre de cookies partitionnés (CHIPS) : la
// session ouverte dans un onglet normal n'y existe pas — d'où le « double
// login » historique. L'extension, elle, sait lire les cookies de toutes les
// partitions (background v4.13). Au boot d'un contexte embarqué non connecté,
// on lui demande donc le jeton d'accès ; s'il arrive, POST /auth/ext-bootstrap
// le convertit en cookies dans NOTRE jarre et la session vaut partout.
import axios from 'axios';
import { API_URL } from './api';
import { isAllowedOrigin } from '../hooks/useExtensionMessages';

export function tryExtensionBootstrap({ timeoutMs = 1500 } = {}) {
  return new Promise((resolve) => {
    if (typeof window === 'undefined' || window.self === window.top) {
      resolve(false);
      return;
    }
    let settled = false;
    const finish = (ok) => {
      if (settled) return;
      settled = true;
      window.removeEventListener('message', onMessage);
      resolve(ok);
    };
    const timer = setTimeout(() => finish(false), timeoutMs);

    async function onMessage(event) {
      // Le jeton ne peut venir que du parent direct : le side panel de
      // l'extension (chrome-extension://) ou la page Doctolib où vit le
      // content script relayeur.
      const fromExtension = typeof event.origin === 'string' && event.origin.startsWith('chrome-extension://');
      if (!fromExtension && !isAllowedOrigin(event.origin)) return;
      if (event.source !== window.parent) return;
      const token = event.data && event.data.type === 'MEDIPOCKET_AUTH_TOKEN' ? event.data.token : null;
      if (!token) return;
      clearTimeout(timer);
      try {
        await axios.post(
          `${API_URL}/api/auth/ext-bootstrap`,
          {},
          { headers: { Authorization: `Bearer ${token}` }, withCredentials: true, timeout: 8000 },
        );
        finish(true);
      } catch (_) {
        finish(false);
      }
    }

    window.addEventListener('message', onMessage);
    // La DEMANDE ne contient aucune donnée (un simple type) et le parent peut
    // être Doctolib ou le side panel — origine inconnue d'avance, d'où '*'.
    // La RÉPONSE porteuse du jeton est, elle, validée origine + source ci-dessus.
    window.parent.postMessage({ type: 'MEDIPOCKET_REQUEST_AUTH' }, '*');
  });
}
